module.exports = __webpack_public_path__ + "media/3dvideo.245c5386.mp4";